import type BrandSubscriptionModel from '../store/schema/BrandSubscriptionModel';
import type BrandSubscriptionStore from './schema/BrandSubscriptionStore';
import type { BrandSubscriptionAccountStore } from './schema/BrandSubscriptionStore';
import { createStore } from 'owa-satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';

const getStore: () => BrandSubscriptionStore = createStore<BrandSubscriptionStore>(
    'BrandSubscription',
    {
        accountStores: new Map(),
    }
);

function getDefaultAccountStore(): BrandSubscriptionAccountStore {
    return {
        subscriptions: new Map<string, BrandSubscriptionModel>(),
        unsubscribedSubscriptions: new Map<string, BrandSubscriptionModel>(),
    };
}

export default function getBrandSubscriptionStoreForAccount(
    mailboxInfo: MailboxInfo
): BrandSubscriptionAccountStore {
    const store = getStore();
    const accountKey = getIndexerValueForMailboxInfo(mailboxInfo);
    let accountStore = store.accountStores.get(accountKey);
    if (!accountStore) {
        accountStore = getDefaultAccountStore();
        store.accountStores.set(accountKey, accountStore);
    }
    return accountStore;
}
